export class UserSummaryProductModel {
    id: number;
    billingCtn: string;
    fan: string;
    productDescription: string;
    productName: string;
    serviceOfferCode: string;
    extProperties: Array<Object>;
    licenseClientId: string;
    clientId: string;
    fanType: string;
    fanTypeFlag: boolean;
}
